module.exports = __webpack_public_path__ + "img/1.d41bd517.png";